<template>
  <b-navbar class="full-nav py-2" toggleable="md" type="info" v-if="company">

    <b-navbar-brand class="m-0 my-1 mr-md-3" href="/" :title="companyName">
      <img v-if="companyLogo" :src="companyLogo"/>
      <h2 v-else>{{ companyName }}</h2>
    </b-navbar-brand>

    <b-navbar-toggle target="nav_collapse"><font-awesome-icon icon="bars"/></b-navbar-toggle>

    <b-collapse is-nav id="nav_collapse">
      <b-navbar-nav class="nav-wide mt-3 mt-md-0 px-2 px-md-0" v-if="isLoggedIn">

        <b-nav-item :to="{ name: 'MentorsIndex' }" title="Mentors">
          <font-awesome-icon icon="users" />
          <span class="d-inline-block d-md-none d-lg-inline-block">{{ isCXR ? 'All Colleagues' : 'All Mentors' }}</span>
        </b-nav-item>

        <b-nav-item :to="{ name: 'UserMentorship' }" title="Mentor Requests">
          <font-awesome-icon icon="chalkboard-teacher" />
          <span class="d-inline-block d-md-none d-lg-inline-block">{{ isCXR ? 'Connection Requests' : 'Mentor Requests' }}</span>
        </b-nav-item>

        <!-- <b-nav-item to="/candidates"><font-awesome-icon icon="user" />Candidates</b-nav-item> -->

        <b-nav-item-dropdown v-if="isRecruiter" title="Admin">
          <template v-slot:button-content>
            <font-awesome-icon icon="user-shield"/>
            <span class="d-inline-block d-md-none d-lg-inline-block">Admin</span>
          </template>
          <b-dropdown-item :to="{ name: 'ListUsers' }">
            <font-awesome-icon class="mr-2" icon="users" />Users
          </b-dropdown-item>
        </b-nav-item-dropdown>

      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto mt-3 mt-md-0 px-2 px-md-0">
        <template v-if="user">
          <!-- <b-nav-item class="d-inline-flex align-items-top">
            <font-awesome-icon icon="bell"/>
            <span class="d-md-none">Notifications</span>
            <b-badge pill variant="danger">1</b-badge>
          </b-nav-item> -->
          <b-nav-item class="secondary-color-semi-opaque" href="https://gwr.reallinks.io/" v-if="$root.isGWRReferrals">
            <font-awesome-icon icon="arrow-up" class="primary-color-semi-opaque" />
            GWR Internal Mobility
          </b-nav-item>
          <b-nav-item class="secondary-color-semi-opaque" href="https://gwr-referrals.reallinks.io/" v-if="$root.isGWR">
            <font-awesome-icon icon="handshake" class="primary-color-semi-opaque" />
            GWR Referrals
          </b-nav-item>

          <b-nav-item-dropdown right no-caret toggle-class="py-0">
            <template v-slot:button-content>
              <div class="d-inline-flex justify-content-between align-items-center pt-2" :title="user.fullName">
                <avatar :user="user" :size="30"/>
                <div class="ml-3 mr-2" style="line-height: 14px">
                  <b>{{ user.fullName }}</b><br/>{{ user.title }}
                </div>
                <font-awesome-icon class="ml-1" icon="caret-down"/>
              </div>
            </template>

            <b-dropdown-item :to="{ name: 'ProfileEdit' }">
              <font-awesome-icon class="mr-2" icon="user"/> Profile
            </b-dropdown-item>
            <b-dropdown-item :to="{ name: 'ProfileSessions' }">
              <font-awesome-icon class="mr-2" icon="list-alt"/> Your Sessions
            </b-dropdown-item>
            <b-dropdown-item href="https://real-links-assets.s3.eu-west-2.amazonaws.com/cxr-lBAqB/2023-04-30/01GZ9C98Z8VB7K95Q6KNNW62CR/talktank-faqs.pdf" target="_blank" v-if="isCXR">
              <font-awesome-icon class="mr-2" icon="question"/> FAQs
            </b-dropdown-item>

            <b-dropdown-divider v-if="isRecruiter"/>

            <b-dropdown-item v-if="company.shortCode" :to="{ name: 'AppPromo' }">Download App</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'EmailSender' }" v-if="isRecruiterAdmin || (isDemoSite && isRecruiter)">Send Emails</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Settings' }" v-if="isRecruiterAdmin">Settings</b-dropdown-item>

            <template v-if="isDemoSite">
              <b-dropdown-divider/>
              <b-dropdown-text tag="div" class="px-0">
                <demo-nav-opts/>
              </b-dropdown-text>
            </template>

            <template v-if="!isCXR">
              <b-dropdown-divider/>
              <!-- <b-dropdown-item v-if="company && company.siteBranding && !company.siteBranding.helpURL && isRecruiter" :href="helpURLs['Recruiter-FAQs']" target="_blank"><template v-if="isRecruiterAdmin">Recruiter </template>FAQs</b-dropdown-item> -->
              <!-- <b-dropdown-item v-if="company && company.siteBranding && !company.siteBranding.helpURL" :href="helpURLs['Employee-FAQs']" target="_blank"><template v-if="isRecruiter">Employee </template>FAQs</b-dropdown-item> -->
              <!-- <b-dropdown-item :to="{ name: 'TrainingVideo' }">Training Video</b-dropdown-item> -->
              <b-dropdown-item href="https://support.reallinks.io/hc" v-if="isRecruiterAdmin">Support Centre</b-dropdown-item>
              <!-- <b-dropdown-item v-if="isRecruiterAdmin" :to="{ name: 'RecruiterAdminHelp' }">Administration Guide</b-dropdown-item> -->
              <b-dropdown-item v-if="company && company.siteBranding && company.siteBranding.helpURL" :href="company.siteBranding.helpURL.fileLocation" target="_blank">Help</b-dropdown-item>
              <b-dropdown-item v-if="company && company.siteBranding && company.siteBranding.policyURL" :href="company.siteBranding.policyURL.fileLocation" target="_blank">Policy Details</b-dropdown-item>
            </template>

            <b-dropdown-item v-if="user.id === 'ADMIN'" :to="{ name: 'LogoutAdmin' }">Back to Admin</b-dropdown-item>
            <b-dropdown-item :to="{ name: 'Logout' }">Sign Out</b-dropdown-item>
          </b-nav-item-dropdown>
        </template>
      </b-navbar-nav>
    </b-collapse>

  </b-navbar>
</template>

<script>
// import HeaderEmployeeBadges from '@/graphql/queries/HeaderEmployeeBadges.gql';
// import HeaderRecruiterBadges from '@/graphql/queries/HeaderRecruiterBadges.gql';
import Avatar from '@/components/users/Avatar';
import DemoNavOpts from '@/components/DemoNavOpts';
import helpURLs from '@/assets/helpURLs';
import { mapRoot } from '@/mixins/root';

export default {
  components: {
    Avatar,
    DemoNavOpts,
  },
  // apollo: {
  //   badges: {
  //     query() {
  //       return this.isRecruiter ? HeaderRecruiterBadges : HeaderEmployeeBadges;
  //     },
  //     update: data => data,
  //     skip() {
  //       return !this.isLoggedIn;
  //     }
  //   },
  // },
  computed: {
    ...mapRoot([
      'company', 'user', 'isLoggedIn', 'isRecruiter', 'isRecruiterAdmin',
      'isReferralsFeatureEnabled', 'canSyncContacts',
      'isDemoSite', 'isSainsburys', 'isCXR',
    ]),
    companyLogo() {
      const { company } = this;
      return company && company.siteBranding && company.siteBranding.bigLogo ? company.siteBranding.bigLogo.fileLocation : null;
    },
    companyName() {
      const { company } = this;
      return company && company.siteBranding && company.siteBranding.name ? company.siteBranding.name : company.name;
    },
    leaderboards() {
      if (this.isLoggedIn && this.sitePreferences.useGamification) {
        const filterActiveDates = ({ startDate, endDate }) => (!startDate || startDate < Date.now()) && (!endDate || endDate > Date.now());
        if (this.isRecruiter) {
          return (Array.isArray(this.company.leaderboards) ? this.company.leaderboards : []).filter(filterActiveDates);
        } else {
          let leaderboards = (Array.isArray(this.user.leaderboards) ? this.user.leaderboards : []).filter(filterActiveDates).filter(({ hidden }) => (!hidden));
          if (this.company.handle === 'mckesson') {
            leaderboards = leaderboards.filter(({ type }) => type === 'INDIVIDUALS');
          }
          return leaderboards;
        }
      }

      return null;
    },
    visibleInLeaderboards() {
      if (this.isLoggedIn && this.user && this.user.preferences) {
        const { visibleInLeaderboards } = this.user.preferences;
        return visibleInLeaderboards === true || visibleInLeaderboards === null;
      } else {
        return true;
      }
    },
    sitePreferences() {
      const { sitePreferences } = this.company || {};
      return sitePreferences || {};
    },
    helpURLs: () => helpURLs,
    isNewDashboard() {
      const { company } = this;
      return company && company.sitePreferences && company.sitePreferences.isNewDashboard;
    },
  },
};
</script>

<style lang="scss">
.navbar.full-nav {
  .navbar-brand {
    img {
      max-height: 30px;
      max-width: 200px;
      object-fit: contain;
    }
  }

  .navbar-nav {
    .svg-inline--fa {
      width: 16px;
    }

    .nav-item {
      font-size: 13px;
    }

    &.nav-wide {
      .svg-inline--fa {
        margin-right: 10px;
      }

      .nav-item {
        padding-right: 1rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderMentorship.vue